import React from "react"
import {
  Heart,
  Award,
  Mail,
  MapPin,
  CheckCircle2,
  Sliders,
  Coins,
  Laptop,
  Plane,
  Briefcase,
  Image,
  Map,
  Home,
  CreditCard,
  MessageSquare,
  User,
  Lock,
  Book,
  Utensils,
  HelpCircle,
  Layers
} from "lucide-react"

const iconMap = {
  // Common icons
  "heart-1": Heart,
  "love-pin-1": Heart,
  "diploma-1": Award,
  "mail-1": Mail,
  "map-location-1": MapPin,
  "checked-circle-1": CheckCircle2,
  "mix-1": Sliders,
  "coins-1": Coins,
  "laptop-screen-1": Laptop,
  "airplane-mode-1": Plane,
  "suitcase-1": Briefcase,
  "image-gallery-1": Image,
  "destination-map-1": Map,
  "real-estate-1": Home,
  "pay-1": CreditCard,
  "pay-by-card-1": CreditCard,
  "chat-app-1": MessageSquare,
  "identity-1": User,
  "password-1": Lock,
  "diary-1": Book,
  "food-1": Utensils,
}

const Icon = (props) => {
  const IconComponent = iconMap[props.icon] || (props.icon ? HelpCircle : Layers)
  return (
    <IconComponent 
      className={`svg-icon ${props.className ? props.className : ""}`}
      style={props.style}
    />
  )
}

export default Icon
